import React, { useCallback, useEffect, useState } from 'react'
import APIService from '../../Services/API/APIService'
import { Table, Dimmer, Loader, Button, Label } from 'semantic-ui-react'
import dayjs from 'dayjs'
import numeral from 'numeral'
import { toast } from "react-toastify";

const ViewActivity = (props) => {

  const [loading, setLoading] = useState(false)
  const [order, setOrder] = useState([])
  const fetchData = useCallback(async (isSubscribed) => {
    try {
      setLoading(true)
      if(isSubscribed){
      let result = await APIService.getData('/guest-house/viewActivity', {
        GuestHouseUserId: props.selectActivity.GuestHouseUserId,
        checkin: props.selectActivity.checkin,
        checkout: props.selectActivity.checkout,
        GuestHouseBookingId: props.selectActivity.id,
      })
        setOrder(result)
      }

      setLoading(false)
    } catch (error) {
      console.log(error);
      setLoading(false)
    }
  },[props.selectActivity.GuestHouseUserId,props.selectActivity.checkin,props.selectActivity.checkout,props.selectActivity.id])

  useEffect(() => {
    let isSubscribed = true
    fetchData(isSubscribed)
    return () => (isSubscribed = false)
  }, [fetchData])



  const removeItem = async (item) => {
    try {
 
      setLoading(true)

      await APIService.postData('/guest-house/removeItem', {
        itemId: item.id,
        name: item.name,
        price: item.price,
        GuestHouseBookingId: item.GuestHouseBookingId,
        GuestHouseUserId: item.GuestHouseUserId,
        bookingCode: props.selectActivity.bookingId,
        GuestHousePaymentId: item.GuestHousePaymentId

      })

      setLoading(false)
      fetchData(true)
      toast.success('Deleted Successfully')
    } catch (error) {
      console.log(error);
      setLoading(false)
    }
  }

  let counter = 0
  // const roomLength = (bookingId) => {
  //   return order.filter((a) => a.name == 'Room' && a.GuestHouseBookingId == bookingId).length

  // }
  const orderItems = order?.map((item) => (

    <Table.Row key={item.id}>

      <Table.Cell> {counter = counter + 1}</Table.Cell>

      <Table.Cell>{item?.name}</Table.Cell>
      <Table.Cell>
        ₦{numeral(item?.price).format("0,0")}
      </Table.Cell>
      <Table.Cell>
        ₦{numeral(item?.discount).format("0,0")}
      </Table.Cell>

      <Table.Cell>
        ₦{numeral(item?.price - item?.discount).format("0,0")}
      </Table.Cell>

      <Table.Cell>{dayjs(item.date).format("DD-MMM-YYYY")}</Table.Cell>
      <Table.Cell>
        <Label color={ item.status === 'INVOICED'? item.status  === 'POS' ? 'orange' : 'olive': 'violet'} >{item.status}</Label>
      </Table.Cell>
      <Table.Cell>
         {item?.description}
      </Table.Cell>
      <Table.Cell>
        {props.selectActivity.checkedIn === true && props.selectActivity.checkedOut === false && (
          <Label color='red' basic onClick={() => removeItem(item)}>  Delete</Label>
        )}

      </Table.Cell>


    </Table.Row>
  ));




 const handlePdf = async (igg) => {
  try {
    setLoading(true)
    await APIService.downloadfile('/analytics/downloadReceipt', {
      bookingId : props.selectActivity.bookingId,
      checkin : props.selectActivity.checkin,
      checkout : props.selectActivity.checkout,
      booking : props.selectActivity.id
    }

    )

    toast.success('Download Completed')
    setLoading(false)

  } catch (error) {
    setLoading(false)
    toast.warn(error)

  }
}
  return (
    <div>
      {loading && (
        <Dimmer active inverted>
          <Loader content='please wait ...' />
        </Dimmer>
      )}
      <Button  onClick={() => handlePdf()}  style={{ backgroundColor: '#26f09e', color: '#000000' }}> Download receipt</Button>
      {order && (
        <Table striped stackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>S/N</Table.HeaderCell>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Price</Table.HeaderCell>
              <Table.HeaderCell>Discount</Table.HeaderCell>
              <Table.HeaderCell>Room Discount Price </Table.HeaderCell>
              <Table.HeaderCell>Date</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell>Description</Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>

            </Table.Row>
          </Table.Header>

          <Table.Body>{orderItems}</Table.Body>
        </Table>
      )}
    </div>
  )
}

export default ViewActivity